<template>
  <div>
    <AppHeader  />
    <div class="activities">
    <div class="activities__preview">
      <v-container class="activities__preview-inner white--text">
        <v-layout>
          <v-flex>
            <h1 class="activities__preview-title">
               Discover <br> charity challenge
            </h1>
            <v-form class="activities_search-form">
              <div class="activities_search-inner">
                <v-autocomplete
                  v-model="searchActivity"
                  :items="getActivities"
                  item-value="id"
                  item-text="name"
                  label="Search activities"
                  height="56px"
                  single-line
                  solo
                  depressed
                  clearable
                  color="teal lighten-2"
                  prepend-inner-icon="fas fa-search fa-1x"
                />
              </div>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-container>
      <v-layout row>
        <v-flex md12>
          <h2 class="app-title">
            Popular
            <router-link
              to="search"
              class="title-link"
            >
              See all activities
              <i class="fas fa-chevron-right" />
            </router-link>
          </h2>

          <!-- swiper -->
          <swiper v-if="loaded" :options="swiperOption">

            <swiper-slide
              class="activities-slider"
              v-for="activity in filteredActivities"
              :key="activity.id"
            >
              <router-link
                class="popular_slide"
                :to="{ name: 'activity', params: { id: activity.id }}"
              >
                <v-card>
                  <v-img
                    class="white--text"
                    height="150px"
                    :src="activity.image"
                  />
                  <v-card-title>
                    <span>{{ activity.name }}</span>
                  </v-card-title>
                </v-card>
              </router-link>
            </swiper-slide>
          </swiper>
              <div v-else class="text-xs-center">
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
    </div>
        </v-flex>
      </v-layout>

      <br>
      <br>

      <v-layout row>
        <v-flex md12>
          <h2 class="app-title">
            Leaderboard
          </h2>

          <v-card
            to="leaderboard"
          >
            <v-img
              class="white--text"
              height="100px"
              :src="require('../assets/leaderboard.jpg')"
            />
          </v-card>
        </v-flex>
      </v-layout>

      <br>
      <br>

      <v-layout row>
        <v-flex md12>
          <h2 class="app-title">
            Articles
          </h2>

          <v-card
            to="articles"
          >
            <v-img
              class="white--text"
              height="100px"
              :src="require('../assets/articles.jpg')"
            >
              <v-container fluid>
                <v-layout fill-height>
                  <v-flex
                    xs12
                    align-end
                    flexbox
                  >
                    <h3>
                      News
                    </h3>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>

      <br>
      <br>

      <v-layout row>
        <v-flex md12>
          <v-img
            class="white--text"
            width="280px"
            height="auto"
            :src="require('../assets/logo.jpg')"
          />
          <br>

          <h3>NMG’s CHARITY CHALLENGE</h3>
          <p>
            is an annual fundraising event for employees, alumni and family. From 1 June to 31 August teams from all of the NMG Group businesses run, walk, swim, cycle, … and fundraise, all in the name of raising money for deserving charities.
          </p>
          <br>
          <br>
          <br>
        </v-flex>
      </v-layout>
    </v-container>

    <BottomNavigation />
  </div>
  </div>
</template>

<script>

  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import AppHeader from '../components/AppHeader';
  import BottomNavigation from "../components/BottomNavigation";
  ///import { ACTIVITIES_REQUEST } from '../store/actions/activities';
  import 'swiper/dist/css/swiper.css';
  import { mapGetters } from 'vuex';

  export default {
    name: 'Activities',
    components: {
      swiper,
      swiperSlide,
      AppHeader,
      BottomNavigation
    },
    data() {
      return {
        searchActivity: "",
        loaded: false,
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 20,
          // init: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 40
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            }
          }
        }
      }
    },
    computed: {
            ...mapGetters(
        'activity', ['getActivities',],
        ),
      //activityOptions: function () {
     //   return this.$store.getters.getActivities;
     // },
      filteredActivities: function () {
        if (this.searchActivity) {
          return this.getActivities.filter(activity => activity.id === this.searchActivity);
        }
        return this.getActivities;
      }
    },
    mounted() {
      this.$store.dispatch('activity/activitiesRequest').then(() => {
          this.loaded = true;
          })
          .catch(err => {
            
            });
    },
  }


</script>

<style scoped>
  .activities__preview {
    display: flex;
    padding: 45px 0;
    background-color: #272727;
    margin-bottom: 60px;
  }

  .activities__preview-title {
    font-size: 30px;
    line-height: 35px;
    padding: 0 15px;
  }

  .activities__preview-inner {
    position: relative;
    display: flex;
    height: 100%;
  }

  .activities_search-form {
    position: absolute;
    bottom: -75px;
    left: 0;
    width: 100%;
    padding: 0 15px;
  }

  .activities_search-inner {
    display: flex;
    width: 100%;
    height: 56px;
  }

  .activities_search-input {
    width: calc(100% - 56px);
    background-color: #fff;
    margin: 0;
    height: 100%;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    padding: 0 15px;
    color: #6e8ca0;
    outline: none;
  }

  .activities_search-button {
    position: relative;
    left: -2px;
    width: 56px;
    height: 100%;
    margin: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .popular_slide {
    display: block;
    margin: 5px;
    text-decoration: none;
    text-align: center;
  }
  .v-progress-circular{
    margin: 1rem;
  }

</style>
